export default __webpack_public_path__ + "static/nextkraftwerke-teaser-ba2385d2216a620ee694154171b3e68d.png";